<div class="order-container"
     [class.modal-container]="isModal">
    <ion-item *ngIf="showTabInfo && !!tab && tab.status !== tabStatuses.PENDING"
              [class.tab-summary]="!activeMembership"
              [class.tab-summary-member]="!!activeMembership"
              class="pointer order-container-tab-header"
              routerLink="/manager/{{pickupLocation.id}}}/tab/{{tab.id}}">
        <bb-tokens *ngIf="!!organization.tokenGroups && organization.tokenGroups.length > 0" [count]="availableTokens" slot="start"></bb-tokens>
        <ion-label>
            {{ (!!tab.nameOverride && terminalMode) ? tab.nameOverride : (!!tab.person ? tab.person.name : 'Terminal Order') }}
            <p><span *ngIf="!!tab.customerAreaPosition">{{ tab.customerAreaPosition.formattedValue() }}</span> ({{ tab.startTime | dateAgo }})</p>
        </ion-label>

        <ion-note *ngIf="!!tab && !!tab.paymentInformation" slot="end">{{ tab.paymentInformation.invoiced | currency }}</ion-note>
    </ion-item>
    <div class="order-container-header">
        <div *ngIf="terminalMode && (!tab || tab.status === tabStatuses.PENDING) && !!organization.membershipPrograms && organization.membershipPrograms.length > 0"
             class="active-membership">
            <ion-button [color]="!!activeMembership ? 'primary' : 'dark'"
                        class="membership-button"
                        (click)="selectMember.emit()">
                <ng-container *ngIf="!activeMembership">No {{ organization.membershipLabel }}</ng-container>
                <ng-container *ngIf="!!activeMembership">
                    <div class="membership-container">
                        <h3 *ngIf="!!organization.tokenGroups && organization.tokenGroups.length > 0" class="member-tokens">
                            <bb-tokens [count]="availableTokens"></bb-tokens>
                        </h3>
                        <div class="membership-info">
                            <span>{{ !!activeMembership.person ? activeMembership.person.name : 'No Person Information' }}</span>
                            <p class="sub-header">{{
                                    !!activeMembership.activeMembershipProgram
                                        ? activeMembership.activeMembershipProgram.name
                                        : 'No active program.'
                                }}</p>
                        </div>
                        <div *ngIf="isBirthday" class="birthday">
                            <ion-icon name="gift-outline"></ion-icon>
                        </div>
                    </div>
                </ng-container>
            </ion-button>
            <ion-button *ngIf="!activeMembership" class="add-membership-button" color="tertiary" (click)="renewMembership.emit()">
                <ion-icon name="add-outline" slot="icon-only"></ion-icon>
            </ion-button>
            <ion-button *ngIf="!!activeMembership" class="add-membership-button" color="dark" (click)="removeMember.emit()">
                <ion-icon name="close-outline" slot="icon-only"></ion-icon>
            </ion-button>
        </div>

        <ion-item
                *ngIf="terminalMode && (!tab || tab.status === tabStatuses.PENDING) && !!organization.tabNoteDefinitions && organization.tabNoteDefinitions.length > 0">
            <ion-label position="floating">Tab Notes</ion-label>
            <ion-select [(ngModel)]="noteDefinitions" interface="popover" multiple="true" (ionChange)="selectNoteDefinitions()">
                <ion-select-option *ngFor="let n of organization.tabNoteDefinitions" [value]="n">{{ n.name }}</ion-select-option>
            </ion-select>
        </ion-item>

        <a *ngIf="!!order" class="clear-cart" (click)="clearCart.emit()">Clear Order</a>
    </div>
    <div class="order-container-body" #orderContainer>
        <ion-item *ngIf="!order">
            <ion-text>
                Your order is empty.
            </ion-text>
        </ion-item>

        <ng-container *ngIf="!!tab && !!tab.credits && tab.credits.length > 0">
            <div *ngFor="let comp of tab.credits" class="tab-comp-container">
                <bb-comp-definition [compDefinition]="comp.compDefinition"
                                    (compClick)="removeTabCredit.emit(comp)">
                </bb-comp-definition>
            </div>
        </ng-container>
        <bb-display-order *ngIf="!!order"
                          [order]="order"
                          [availableOrderComps]="availableOrderComps"
                          [hideImages]="terminalMode"
                          (openItemSummary)="openItemSummary.emit($event)"
                          (updateItem)="updateItem.emit($event)"
                          (addToSummary)="addToSummary.emit($event)"
                          (addCredit)="addCredit.emit($event)"
                          (removeCredit)="removeCredit.emit($event)"
                          (removeTokens)="removeTokens.emit($event)"
                          (addTokens)="addTokens.emit($event)"
                          (removeFromSummary)="removeFromSummary.emit($event)"
                          (removeItemSummary)="removeItemSummary.emit($event)"
                          (scrollToItemSummary)="scrollToSummary($event)">
        </bb-display-order>
    </div>
    <div *ngIf="!terminalMode && !!pickupLocation && pickupLocation.status === 'ACTIVE'" class="order-container-footer">
        <ion-button class="pay-now"
                    [class.pay-now-display]="!!order && order.items.length > 0"
                    [class.pay-now-hide]="(!order || order.items.length === 0) && orderAdded"
                    color="dark"
                    (click)="payNowClicked($event)">
            ({{ !!order ? order.items.length : 0 }}) Confirm Order
        </ion-button>
    </div>
    <ion-grid *ngIf="terminalMode" class="footer-button-grid action-buttons">
        <ion-row *ngIf="!!tab && !tab.id && !!tab.paymentInformation">
            <ion-col *ngIf="!tab.cashDue" class="total ion-text-end">
                Total: {{ tab.paymentInformation.remaining | currency }}
            </ion-col>
            <ion-col *ngIf="!!tab.chargeDue" class="total ion-text-end">
                Charge: {{ tab.chargeDue | currency }}
            </ion-col>
            <ion-col *ngIf="!!tab.cashDue" class="total ion-text-end">
                Cash: {{ tab.cashDue | currency }}
            </ion-col>
        </ion-row>
        <ion-row *ngIf="!!order && order.items.length > 0">
            <ion-col [sizeXs]="!tab || tab.status === tabStatuses.PENDING ? 6 : 12">
                <ion-button data-cy="confirm-button"
                            class="full-footer-button payment-option"
                            color="dark"
                            (click)="payNowClicked($event)">
                    ({{ !!order ? order.items.length : 0 }}) Confirm
                </ion-button>
            </ion-col>
            <ion-col *ngIf="!tab || tab.status === tabStatuses.PENDING" size-xs="6">
                <ion-button data-cy="cash-button"
                            class="full-footer-button payment-option"
                            color="dark"
                            [disabled]="!availableTabComps || availableTabComps.length < 1"
                            (click)="payNowClicked($event, 'COMP')">
                    Comp
                </ion-button>
            </ion-col>
            <ion-col *ngIf="!tab || tab.status === tabStatuses.PENDING" size-xs="6">
                <ion-button data-cy="cash-button"
                            class="full-footer-button payment-option"
                            color="dark"
                            (click)="payNowClicked($event, 'GIFT_CARD')">
                    Gift Card
                </ion-button>
            </ion-col>
            <ion-col *ngIf="!tab || tab.status === tabStatuses.PENDING" size-xs="6">
                <ion-button data-cy="cash-button"
                            class="full-footer-button payment-option"
                            color="dark"
                            [disabled]="!cashSession || !cashSession.canAcceptPayments"
                            (click)="payNowClicked($event, 'CASH')">
                    Cash
                </ion-button>
            </ion-col>
            <ion-col *ngIf="!tab || tab.status === tabStatuses.PENDING" size-xs="6">
                <ion-button data-cy="credit-card-button"
                            class="full-footer-button payment-option"
                            color="tertiary"
                            [disabled]="!terminal"
                            (click)="payNowClicked($event, 'CHARGE')">
                    Card
                </ion-button>
            </ion-col>
            <ion-col *ngIf="!tab || tab.status === tabStatuses.PENDING" size-xs="6">
                <ion-button data-cy="start-tab-button"
                            class="full-footer-button payment-option"
                            color="success"
                            [disabled]="!!order.deposits"
                            bbLongPress
                            (longPress)="startBlankTab()"
                            (click)="payNowClicked($event, 'START_TAB')">
                    <div class="start-tab-container">
                        <span>Start Tab</span>
                        <p>Hold For No Card</p>
                    </div>
                </ion-button>
            </ion-col>
        </ion-row>
        <ion-row *ngIf="!order && !tab">
            <ion-col size-xs="12">
                <ion-button data-cy="start-tab-button"
                            class="full-footer-button payment-option"
                            color="dark"
                            (click)="payNowClicked($event, 'START_BLANK_TAB')">
                    Create Empty Tab
                </ion-button>
            </ion-col>
        </ion-row>
    </ion-grid>
</div>
